import { render, staticRenderFns } from "./DxWeatherElementBarsGraph.vue?vue&type=template&id=bbfa7238&scoped=true&"
import script from "./DxWeatherElementBarsGraph.vue?vue&type=script&lang=js&"
export * from "./DxWeatherElementBarsGraph.vue?vue&type=script&lang=js&"
import style0 from "./DxWeatherElementBarsGraph.vue?vue&type=style&index=0&id=bbfa7238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfa7238",
  null
  
)

export default component.exports